<template>
  <div class="w400">
    <el-form class="pop-form-wrap" label-width="90px" :model="formData" ref="commonForm" v-if="formData">
      <slot></slot>
      <el-form-item label="Start time" prop="minTime">
        <el-date-picker v-model="formData.minTime" type="date"></el-date-picker>
      </el-form-item>
      <el-form-item label="End time" prop="maxTime">
        <el-date-picker v-model="formData.maxTime" type="date"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <div class="pop-center-btn-wrap">
          <el-button type="primary" @click="doExport('commonForm')">Confirm export</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import $ from 'jquery'
import tools from '@/components/common/tools'
import config from '@/components/common/config'

// 数据对象
let dataStore = tools.createDataStore({
  minTime: '',
  maxTime: ''
})

// 请求相关操作
let page = {
  methods: {
    // 新增操作
    addDataAjax() {
      let data = tools.getModel(this.formData)
      let extraData = this.extraData || {}
      let param = $.extend({
        All: 1,
        MinTime: data.minTime,
        MaxTime: data.maxTime
      }, extraData)
      this.$emit('FormClose')
      // console.log(param)
      // console.log(this.url)
      window.open(config.AjaxUrl + this.url + '?' + $.param(param))
    }
  }
}

export default {
  name: 'ExportForm',
  componentName: 'ExportForm',
  mixins: [page],
  data() {
    return {
      formData: dataStore.getDefaultData()
    }
  },
  props: [
    'url',
    'extraData'
  ],
  methods: {
    // 重置表单值
    resetValue() {
      this.formData = dataStore.getDefaultData()
    },
    // 设置表单值
    setValue(value) {
      this.formData = tools.extendData(dataStore.getDefaultData(), value || {})
    },
    // 发布
    doExport(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// ExportForm.vue?02ddb424